import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/quote.svg` */
export const QuoteIcon = createTripletGlyphIcon('QuoteIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.93982 3.06335H12.3239M5.54871 7.52339H14.0602M5.54871 11.8813H14.0602M2.5186 6.39987V12.9367"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.18225 3.44629H13.8643M6.24225 8.46383H15.8177M6.24225 13.3665H15.8177M2.83338 7.19987V14.5538"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.77832 8.84961C4.19223 8.84987 4.52819 9.18567 4.52832 9.59961V19.4053C4.52806 19.8191 4.19215 20.155 3.77832 20.1553C3.36428 20.1553 3.02858 19.8193 3.02832 19.4053V9.59961C3.02845 9.18551 3.36419 8.84962 3.77832 8.84961Z"
        fill="currentColor"
      />
      <path
        d="M21.0908 17.0713C21.5046 17.0716 21.8405 17.4075 21.8408 17.8213C21.8408 18.2353 21.5048 18.571 21.0908 18.5713H8.32324C7.90914 18.5712 7.57324 18.2354 7.57324 17.8213C7.57356 17.4074 7.90934 17.0714 8.32324 17.0713H21.0908Z"
        fill="currentColor"
      />
      <path
        d="M21.0908 10.5352C21.5047 10.5354 21.8407 10.8712 21.8408 11.2852C21.8406 11.699 21.5047 12.0349 21.0908 12.0352H8.32324C7.90927 12.035 7.57344 11.6991 7.57324 11.2852C7.57337 10.8711 7.90923 10.5353 8.32324 10.5352H21.0908Z"
        fill="currentColor"
      />
      <path
        d="M18.4863 3.84473C18.9002 3.84502 19.2362 4.18081 19.2363 4.59473C19.2363 5.00876 18.9003 5.34443 18.4863 5.34473H2.91016C2.49594 5.34473 2.15918 5.00894 2.15918 4.59473C2.15931 4.18063 2.49602 3.84473 2.91016 3.84473H18.4863Z"
        fill="currentColor"
      />
    </svg>
  ),
});
